import { render, staticRenderFns } from "./Yingjian.vue?vue&type=template&id=037d64f9&scoped=true&"
import script from "./Yingjian.vue?vue&type=script&lang=js&"
export * from "./Yingjian.vue?vue&type=script&lang=js&"
import style0 from "./Yingjian.vue?vue&type=style&index=0&id=037d64f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037d64f9",
  null
  
)

export default component.exports